import styled from 'styled-components';
import { BodyRegularL } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';

export const NotFoundCont = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${({ theme }: IThemeProvider) => `
    margin: ${theme.layout.spacing.deka} 0 0;
  `}
`;

export const NotFoundTitle = styled(BodyRegularL)`
  max-width: 500px;
  text-align: center;

  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[100]}
  `}
`;
